import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { getSocketIoPath } from '../../core/config/api';

interface UseConfigSocketCallbacks {
  onPersonnelCreated?: (data: any) => void;
  onPersonnelUpdated?: (data: any) => void;
  onPersonnelDeleted?: (data: { id: number }) => void;
  onVehiculeCreated?: (data: any) => void;
  onVehiculeUpdated?: (data: any) => void;
  onVehiculeDeleted?: (data: { id: number }) => void;
  onCompetenceCreated?: (data: any) => void;
  onCompetenceUpdated?: (data: any) => void;
  onCompetenceDeleted?: (data: { id: number }) => void;
}

/**
 * Hook pour gérer la connexion Socket.io pour les mises à jour de configuration en temps réel
 */
export const useConfigSocket = (callbacks: UseConfigSocketCallbacks) => {
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    // Créer la connexion Socket.io
    const token = localStorage.getItem('token') || '';
    const socket = io({
      path: getSocketIoPath(),
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
    });

    socketRef.current = socket;

    // Écouter les événements de configuration
    socket.on('config:personnel:created', (data) => {
      callbacks.onPersonnelCreated?.(data);
    });

    socket.on('config:personnel:updated', (data) => {
      callbacks.onPersonnelUpdated?.(data);
    });

    socket.on('config:personnel:deleted', (data) => {
      callbacks.onPersonnelDeleted?.(data);
    });

    socket.on('config:vehicule:created', (data) => {
      callbacks.onVehiculeCreated?.(data);
    });

    socket.on('config:vehicule:updated', (data) => {
      callbacks.onVehiculeUpdated?.(data);
    });

    socket.on('config:vehicule:deleted', (data) => {
      callbacks.onVehiculeDeleted?.(data);
    });

    socket.on('config:competence:created', (data) => {
      callbacks.onCompetenceCreated?.(data);
    });

    socket.on('config:competence:updated', (data) => {
      callbacks.onCompetenceUpdated?.(data);
    });

    socket.on('config:competence:deleted', (data) => {
      callbacks.onCompetenceDeleted?.(data);
    });

    socket.on('connect', () => {
      console.log('🔌 Socket.io connecté pour les configurations');
    });

    socket.on('disconnect', () => {
      console.log('🔌 Socket.io déconnecté');
    });

    socket.on('connect_error', (error) => {
      console.error('❌ Erreur de connexion Socket.io:', error);
    });

    // Cleanup
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [callbacks]);

  return socketRef.current;
};

export default useConfigSocket;

